module.exports = __webpack_public_path__ + "img/tutorial_three_nl.5c2a109f.png";